export default function formatNumber(
  number: number,
  { maxDecimals = 1 }: { maxDecimals?: number } = {},
) {
  return parseFloat(number.toFixed(maxDecimals)).toLocaleString();
}

export const getNumberWithOrdinal = (n: number) => {
  const s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
